import { Component } from '@angular/core';
import { DeclineSuccessComponent } from '../../decline-success/decline-success.component';
import { AllBidsSubmittedDialogComponent } from '../../allbids-submitted-dialog/allbids-submitted-dialog.component';
import { ProjectOverviewContainerComponent } from '../project-overview-container/project-overview-container.component';
import { CommonModule } from '@angular/common';
import { getStoredUser } from '../../helpers/user-storage.util';
import { ProjectService } from '../../services/project.service';
import { ModalService } from '../../services/modal.service';
import { CommonUtilityServiceService } from '../../services/common-utility-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AtpSignAcceptedDialogComponent } from '../../atp-sign-accepted-dialog/atp-sign-accepted-dialog.component';
import { AppService } from '../../services/app.service';
import { AcceptedOfferedProposalDialogComponent } from '../../accepted-offered-proposal-dialog/accepted-offered-proposal-dialog.component';
import { SiteVisitConfirmationDialogComponent } from '../../site-visit/site-visit-confirmation-dialog/site-visit-confirmation-dialog.component';

@Component({
  selector: 'project-overview-page',
  standalone: true,
  imports: [
    CommonModule,
    ProjectOverviewContainerComponent,
    AllBidsSubmittedDialogComponent,
    AtpSignAcceptedDialogComponent,
    DeclineSuccessComponent,
    AcceptedOfferedProposalDialogComponent,
    SiteVisitConfirmationDialogComponent,
  ],
  templateUrl: './project-overview-page.component.html',
  styleUrl: './project-overview-page.component.scss',
})
export class ProjectOverviewPageComponent {
  data: any = [];
  user = getStoredUser();
  bidSubmittedActive: boolean = false;
  declineSuccessActive: boolean = false;
  siteVisitConfirmationActive = false;
  atpModalHeaderTitle: string = 'ATP Signed & Project Active';
  atpModalBody: string =
    'You have signed the ATP and the project can be viewed from the Active tab.';
  isATPSignedAccepted: boolean = false;
  isOfferAcceptedActive: boolean = false;
  address: any = { streetAddress: '', cityStateZip: '' };
  loading: boolean = true;
  enableSubmitAllBids: boolean = false;
  enableAcceptAllOffers = false;
  numberOfBids: number = 0;
  showAtp: boolean = false;
  isFixedPrice: boolean = false;
  isAtp: boolean = false;
  redirectUrl: string = '';

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private modalService: ModalService,
    private utilityService: CommonUtilityServiceService,
    private appService: AppService,
    public router: Router
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id') || '';
      this.projectService
        .refetchData(this.user.id ?? '')
        .subscribe((result) => {
          if (result) {
            this.data = result.find(
              (projectDetail: any) => projectDetail.projectId === id
            );
            this.data = {
              ...this.data,
              sites: this.data?.sites?.filter(
                (siteDetail: any) => siteDetail.proposal.status !== 'DECLINED'
              ),
            };
            this.numberOfBids = this.data?.sites?.filter(
              (siteDetail: any) =>
                siteDetail.proposal.status === 'INVITATION' &&
                siteDetail.proposal.bid > 0 &&
                siteDetail.proposal.proposedTurnTime > 0
            ).length;
            this.enableSubmitAllBids = this.numberOfBids > 0;
            this.enableAcceptAllOffers = this.data?.sites?.some(
              (site: { proposal: { status: string } }) =>
                site.proposal?.status === 'OFFERED'
            );
            this.showAtp = this.data?.sites?.some(
              (site: { proposal: { status: string } }) =>
                site.proposal?.status === 'BID_WON'
            );
            this.loading = false;
          }
        });
    });
    this.modalService.isSubmittedAllBidsModalOpen.subscribe(
      (isOpen) => (this.bidSubmittedActive = isOpen)
    );
    this.modalService.isSignedAtpModalOpen.subscribe((atp) => {
      this.isATPSignedAccepted = atp.open;
    });
    this.modalService.isDeclineModalOpen.subscribe((detail) => {
      if (detail.isOpen) {
        this.declineSuccessActive = true;
        this.isFixedPrice = detail.isFixedPrice;
        this.isAtp = detail.isAtp;
        if (detail.siteDetail.site) {
          this.address = this.utilityService.formatAddress(detail.siteDetail);
        }
      }
    });
    this.modalService.isOfferAcceptedModalOpen.subscribe((isOpen) => {
      this.isOfferAcceptedActive = isOpen;
    });
    this.modalService.siteVisitConfirmationModalOpen.subscribe((isOpen) => {
      this.siteVisitConfirmationActive = isOpen;
    });
    this.appService.redirectUrl.subscribe((url) => (this.redirectUrl = url));
  }

  toggleCloseSubmittedAllBidsModal() {
    this.modalService.toggleCloseSubmittedAllBidsModal();
  }

  toggleCloseDeclineSuccessModal() {
    this.modalService.toggleCloseDeclineSuccessModal();
  }

  toggleCloseAtpAcceptedModal() {
    this.modalService.toggleCloseSignedAtpModal();
  }

  toggleCloseOfferAcceptedModal() {
    this.modalService.toggleCloseOfferAcceptedModal();
  }

  toggleCloseSiteVisitConfirmationModal() {
    this.modalService.toggleCloseSiteVisitConfirmationModal();
  }

  goBack() {
    if (this.redirectUrl?.length > 0 || window.history.length <= 1) {
      this.router.navigate(['invitations']);
      this.appService.setRedirectUrl('');
    } else {
      window.history.back();
    }
  }
}
